interface IMember {
  name: string,
  title: "faculty" | "phd" | "master" | "undergraduate" | "alumni",
  titleDisplay: string[],
  email: string | null,
  directions: string[],
  homepageUrl: string | null,
  photoSrc: string,
  hide_cn?: true,
  hide_en?: true,

  name_en: string,
  titleDisplay_en: string[],
  directions_en: string[],
}

/**
 *
 * "1"	"沈国江"	"教授"	"gjshen1975@zjut.edu.cn"	"智慧城市,智能交通系统,大数据技术"	0	"memberimage/导师/s1.jpg"	"Guojiang Shen"	"Professor"	"Smart city,Intelligent transportation system,Big data technology"	"Faculty"
"2"	"孔祥杰"	"教授,(联系人)"	"xjkong@ieee.org"	"数据科学,网络科学,计算社会科学"	0	"memberimage/导师/XiangjieKong.jpg"	"Xiangjie Kong"	"Professor,(Contact)"	"Data science,Network science,Computational social science"	"Faculty"
"3"	"刘志"	"教授"	"lzhi@zjut.edu.cn"	"智能交通,三维模型检索"	0	"memberimage/导师/ZhiLiu.jpg"	"Zhi Liu"	"Professor"	"Intelligent Transportation,3D model retrieval"	"Faculty"
"4"	"郑建炜"	"副教授"	"zjw@zjut.edu.cn"	"数据分析,机器学习,数值最优化"	0	"memberimage/导师/JianweiZhen.jpg"	"Jianwei Zhen"	"Associate Professor"	"Data analysis,Machine learning,Numerical optimization"	"Faculty"
"5"	"许金山"	"副教授"	"jxu@zjut.edu.cn"	"	医学信息处理与智能医疗,生物肌电信号处理与分析,机器学习,太阳能热发电技术"	0	"memberimage/导师/JinshanXu.jpg"	"Jinshan Xu"	"Associate Professor"	"Medical Information Processing and Smart Medicine,Bio-EMG information processing and analysis,Machine learning,Solar thermal power generation technology"	"Faculty"
*/

export const faculty: IMember[] = [
  {
    name: "沈国江",
    title: "faculty",
    titleDisplay: ["教授"],
    email: "gjshen1975@zjut.edu.cn",
    directions: ["智慧城市", "智能交通系统", "大数据技术"],
    homepageUrl: null,
    photoSrc: "/images/members/faculty/GuojiangShen.jpg",
    name_en: "Guojiang Shen",
    titleDisplay_en: ["Professor"],
    directions_en: ["Smart city", "Intelligent transportation system", "Big data technology"],
  },
  {
    name: "孔祥杰",
    title: "faculty",
    titleDisplay: ["教授", "(联系人)"],
    email: "xjkong@ieee.org",
    directions: ["数据科学", "网络科学", "计算社会科学"],
    homepageUrl: "http://www.cssclab.cn/xjkong/",
    photoSrc: "/images/members/faculty/XiangjieKong.jpg",
    name_en: "Xiangjie Kong",
    titleDisplay_en: ["Professor", "(Contact)"],
    directions_en: ["Data science", "Network science", "Computational social science"],
  },
  {
    name: "朱李楠",
    title: "faculty",
    titleDisplay: ["教授"],
    email: "zln@zjut.edu.cn",
    directions: ["自然语言处理", "数据科学","制造业信息化"],
    homepageUrl: null,
    photoSrc: "/images/members/faculty/zhulinan.jpg",
    name_en: "Linan Zhu",
    titleDisplay_en: ["Professor"],
    directions_en: ["NLP", "Data Science","Manufacturing Informatization"],
  },
  {
    name: "刘志",
    title: "faculty",
    titleDisplay: ["教授"],
    email: "lzhi@zjut.edu.cn",
    directions: ["智能交通", "三维模型检索"],
    homepageUrl: null,
    photoSrc: "/images/members/faculty/ZhiLiu.jpg",
    name_en: "Zhi Liu",
    titleDisplay_en: ["Professor"],
    directions_en: ["Intelligent Transportation", "3D model retrieval"],
  },
  // {
  //   name: "郑建炜",
  //   title: "faculty",
  //   titleDisplay: ["副教授"],
  //   email: "zjw@zjut.edu.cn",
  //   directions: ["数据分析", "机器学习", "数值最优化"],
  //   homepageUrl: null,
  //   photoSrc: "/images/members/faculty/JianweiZhen.jpg",
  //   name_en: "Jianwei Zhen",
  //   titleDisplay_en: ["Associate Professor"],
  //   directions_en: ["Data analysis", "Machine learning", "Numerical optimization"],
  // },
  // {
  //   name: "许金山",
  //   title: "faculty",
  //   titleDisplay: ["副教授"],
  //   email: "jxu@zjut.edu.cn",
  //   directions: ["医学信息处理与智能医疗", "生物肌电信号处理与分析", "机器学习", "太阳能热发电技术"],
  //   homepageUrl: null,
  //   photoSrc: "/images/members/faculty/JinshanXu.jpg",
  //   name_en: "	Jinshan Xu",
  //   titleDisplay_en: ["Associate Professor"],
  //   directions_en: [
  //     "Medical Information Processing and Smart Medicine",
  //     "Bio-EMG information processing and analysis",
  //     "Machine learning",
  //     "Solar thermal power generation technology"
  //   ],
  // },
  {
    name: "王蒙蒙",
    title: "faculty",
    titleDisplay: ["特聘副研究员"],
    email: "mengmewang@gmail.com",
    directions: ['计算机视觉','多模态融合感知','具身智能'],
    homepageUrl: null,
    photoSrc: "/images/members/faculty/wangmengmeng.jpg",
    name_en: "Mengmeng Wang",
    titleDisplay_en: ["Specially appointed Associate Researcher"],
    directions_en: ['Computer vision', 'Multimodal fusion perception','Embodied intelligence'],
  },
  {
    name: "杜嘉欣",
    title: "faculty",
    titleDisplay: ["教师"],
    email: "jiaxin.joyce.du@gmail.com",
    directions: ['物联网','边缘智能'],
    homepageUrl: null,
    photoSrc: "/images/members/faculty/dujiaxin.jpg",
    name_en: "Jiaxin Du",
    titleDisplay_en: ["Teacher"],
    directions_en: ['IoT', 'Edge Intelligence'],
  },
  {
    name: "韩笑",
    title: "faculty",
    titleDisplay: ["特聘副研究员"],
    email: "xhan@zjut.edu.cn",
    directions: ['时空数据挖掘','大模型技术','推荐系统','计算理论'],
    homepageUrl: null,
    photoSrc: "/images/members/faculty/hanxiao.jpg",
    name_en: "Xiao Han",
    titleDisplay_en: ["Specially appointed Associate Researcher"],
    directions_en: ['Spatio-temporal data mining', 'Large scale modeling technology', 'Recommendation system', 'Theory of computation'],
  },
  {
    name: "潘企弘",
    title: "faculty",
    titleDisplay: ["教师"],
    email: "panchenji66@gmail.com",
    directions: ['模式识别', '机器学习'],
    homepageUrl: null,
    photoSrc: "/images/members/phd/pqh.png",
    name_en: "Qihong Pan",
    titleDisplay_en: ["Teacher"],
    directions_en: ['Pattern recognition', 'Machine learning'],
  },
  {
    name: "赵振振",
    title: "faculty",
    titleDisplay: ["博士后"],
    email: "zhenzhenzhao_97@outlook.com",
    directions: ['交通预测'],
    homepageUrl: null,
    photoSrc: "/images/members/faculty/zzz.png",
    name_en: "Zhenzhen Zhao",
    titleDisplay_en: ["Post-doctoral"],
    directions_en: ['Traffic prediction'],
  }
]

export const phd: IMember[] = [
  {
    name: "申思",
    title: "phd",
    titleDisplay: ["2017级博士"],
    email: "shensi_1989@126.com",
    directions: ["智能交通", "信号控制", "强化学习"],
    homepageUrl: null,
    photoSrc: "/images/members/phd/SiShen.png",
    name_en: "Si Shen",
    titleDisplay_en: ["2017 PhD Student"],
    directions_en: ["Intelligent transportation", "Signal control", "Reinforcement learning"],
  },
  {
    name: "朱迪锋",
    title: "phd",
    titleDisplay: ["2017级博士"],
    email: "zhudf@usx.edu.cn",
    directions: ["交通大数据", "数据挖掘"],
    homepageUrl: null,
    photoSrc: "/images/members/phd/DifengZhu.png",
    name_en: "Difeng Zhu",
    titleDisplay_en: ["2017 PhD Student"],
    directions_en: ["Transportation big data", "Data mining"],
  },

  {
    name: "SHABANA JOKHIO",
    title: "phd",
    titleDisplay: ["2021级博士"],
    email: "shabanajokhio@hotmail.com",
    directions: ['自动车辆网络中的中间人攻击防护'],
    homepageUrl: null,
    photoSrc: "/images/members/phd/shabana_jpkhio.jpg",
    name_en: "SHABANA JOKHIO",
    titleDisplay_en: ["2021 PhD Student"],
    directions_en: ['PROTECTIONS AGAINST MAN-IN-THE-MIDDLE ATTACKS IN AUTOMATIC VEHICLE NETWORK'],
  },
  {
    name: "顾文杰",
    title: "phd",
    titleDisplay: ["2022级博士"],
    email: "WenjieGu99@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/phd/gwj.jpg",
    name_en: "Wenjie Gu",
    titleDisplay_en: ["2022 PhD Student"],
    directions_en: [],
  },
  {
    name: "帅思越",
    title: "phd",
    titleDisplay: ["2022级博士"],
    email: "SiyueShuai@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/phd/ssy.jpg",
    name_en: "Siyue Shuai",
    titleDisplay_en: ["2022 PhD Student"],
    directions_en: [],
  },
  {
    name: "张玉超",
    title: "phd",
    titleDisplay: ["2022级博士"],
    email: "zhang_yuchao@yeah.net",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/phd/zyc.jpg",
    name_en: "Yuchao Zhang",
    titleDisplay_en: ["2022 PhD Student"],
    directions_en: [],
  },
  {
    name: "徐梦",
    title: "phd",
    titleDisplay: ["2022级博士"],
    email: "gnemux@gmail.com",
    directions: [],
    homepageUrl: 'https://xumeng.me/resume',
    photoSrc: "/images/members/phd/xm.jpg",
    name_en: "Meng Xu",
    titleDisplay_en: ["2022 PhD Student"],
    directions_en: [],
  },
  {
    name: "张文熠",
    title: "phd",
    titleDisplay: ["2024级博士"],
    email: "wyzhang98@outlook.com",
    directions: ["社会计算","手势识别"],
    homepageUrl: null,
    photoSrc: "/images/members/master/zwy.jpg",
    name_en: "Wenyi Zhang",
    titleDisplay_en: ["2024 phD Student"],
    directions_en: ["Social computing","Gesture Recognition"],
  },
  {
    name: "张依媚",
    title: "phd",
    titleDisplay: ["2024级博士"],
    email: "yimeizhang0229@gmail.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/zym.jpg",
    name_en: "Yimei Zhang",
    titleDisplay_en: ["2024 phD Student"],
    directions_en: [],
  },
  {
    name: "翁文超",
    title: "phd",
    titleDisplay: ["2024级博士"],
    email: "wengwenchao11@gmail.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/phd/wfc.jpg",
    name_en: "Wenchao Weng",
    titleDisplay_en: ["2024 phD Student"],
    directions_en: [],
  },
  {
    name: "刘璎辉",
    title: "phd",
    titleDisplay: ["2023级博士"],
    email: "LiuYingHui240@outlook.com",
    directions: ["城市计算","智慧交通","大数据技术"],
    homepageUrl: null,
    photoSrc: "/images/members/master/lyh.jpg",
    name_en: "Yinghui Liu",
    titleDisplay_en: ["2023 phD Student"],
    directions_en: ["Urban computing","Intelligent transportation","Big Data"],
  },
  {
    name: "Syauqie Muhammad Marier(邵齐）",
    title: "phd",
    titleDisplay: ["2023级博士"],
    email: "Syauqie.mm@gmail.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/phd/shaoqi.jpg",
    name_en: "Syauqie Muhammad Marier",
    titleDisplay_en: ["2023 phD Student"],
    directions_en: ["Urban computing","Intelligent transportation","Big Data"],
  },
  {
    name: "Daminov Bahodir (巴火）",
    title: "phd",
    titleDisplay: ["2023级博士"],
    email: "dbek.developer@gmail.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/phd/DaminovBahodir.jpg",
    name_en: "Daminov Bahodir",
    titleDisplay_en: ["2023 phD Student"],
    directions_en: ["Urban computing","Intelligent transportation","Big Data"],
  },
  {
    name: "倪辰昊",
    title: "phd",
    titleDisplay: ["2023级博士"],
    email: "qnch_ut@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/phd/nichenhao.jpg",
    name_en: "Chenhao Ni",
    titleDisplay_en: ["2023 phD Student"],
    directions_en: [],
  },
  {
    name: "陈馨琪",
    title: "phd",
    titleDisplay: ["2024级博士"],
    email: null,
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/phd/chenxinqi.jpg",
    name_en: "Xinqi Chen",
    titleDisplay_en: ["2024 phD Student"],
    directions_en: [],
  },
  {
    name: "Wail Al-Asad(瓦乐)",
    title: "phd",
    titleDisplay: ["2024级博士"],
    email: "wail@zjut.edu.cn",
    directions: ["多输入多输出(MIMO)系统", "混合波束成形", "智能反射面(IRS)", "移动边缘计算(MEC)", "深度学习"],
    homepageUrl: "https://github.com/wail-asad",
    photoSrc: "/images/members/phd/wl.png",
    name_en: "Wail Al-Asad",
    titleDisplay_en: ["2024 PhD Student"],
    directions_en: ["Multiple-Input Multiple-Output (MIMO) systems", "hybrid beamforming", "intelligent reflecting surfaces (IRS)", "mobile edge computing (MEC)", "deep learning"],
  },
  {
    name: "陈祥钒",
    title: "phd",
    titleDisplay: ["2025级博士"],
    email: "xiangfan_chen@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/phd/cxf.jpg",
    name_en: "Xiangfan Chen",
    titleDisplay_en: ["2025 phD Student"],
    directions_en: [],
  },
  {
    name: "季晨",
    title: "phd",
    titleDisplay: ["2025级博士"],
    email: "eatfingersss@gmail.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/phd/jc.png",
    name_en: "Chen Ji",
    titleDisplay_en: ["2025 phD Student"],
    directions_en: [],
  },
  {
    name: "谢君艺",
    title: "phd",
    titleDisplay: ["2025级博士"],
    email: "sumuqing@gmail.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/phd/xjy.png",
    name_en: "Junyi Xie",
    titleDisplay_en: ["2025 phD Student"],
    directions_en: [],
  },
  {
    name: "吕盛",
    title: "phd",
    titleDisplay: ["2025级博士"],
    email: "pencil.lv@gmail.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/phd/ls.png",
    name_en: "Sheng Lv",
    titleDisplay_en: ["2025 phD Student"],
    directions_en: [],
  }
]

export const master: IMember[] = [
  {
    name: "王浩楠",
    title: "master",
    titleDisplay: ["2023级研究生"],
    email: "HaonanWang111@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/whn.jpg",
    name_en: "Haonan Wang",
    titleDisplay_en: ["2023 Master Student"],
    directions_en: [],
  },
  {
    name: "赵宏彦",
    title: "master",
    titleDisplay: ["2023级研究生"],
    email: "zhy554180823@gmail.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/zhy.jpg",
    name_en: "Hongyan Zhao",
    titleDisplay_en: ["2023 Master Student"],
    directions_en: [],
  },
  {
    name: "张恺煜",
    title: "master",
    titleDisplay: ["2023级研究生"],
    email: "starbeamzjut@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/zky.jpg",
    name_en: "Kaiyu Zhang",
    titleDisplay_en: ["2023 Master Student"],
    directions_en: [],
  },
  {
    name: "郭晓磊",
    title: "master",
    titleDisplay: ["2023级研究生"],
    email: "gxl1829271118@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/gxl.jpg",
    name_en: "Xiaolei Guo",
    titleDisplay_en: ["2023 Master Student"],
    directions_en: [],
  },
  {
    name: "戴哲豪",
    title: "master",
    titleDisplay: ["2023级研究生"],
    email: "zhehaodai@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/dzh.jpg",
    name_en: "Zhehao Dai",
    titleDisplay_en: ["2023 Master Student"],
    directions_en: [],
  },
  {
    name: "吴振鹏",
    title: "master",
    titleDisplay: ["2023级研究生"],
    email: "wzpzzz6@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/wzp.jpg",
    name_en: "Zhenpeng Wu",
    titleDisplay_en: ["2023 Master Student"],
    directions_en: [],
  },
  {
    name: "舒灿",
    title: "master",
    titleDisplay: ["2023级研究生"],
    email: "canshu_cs@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/sc.jpg",
    name_en: "Can Shu",
    titleDisplay_en: ["2023 Master Student"],
    directions_en: [],
  },
  {
    name: "朱军伟",
    title: "master",
    titleDisplay: ["2023级研究生"],
    email: "junweizhu01@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/zjw.jpg",
    name_en: "Junwei Zhu",
    titleDisplay_en: ["2023 Master Student"],
    directions_en: [],
  },
  {
    name: "谈昊飞",
    title: "master",
    titleDisplay: ["2023级研究生"],
    email: "haofei_tan@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/thf.jpg",
    name_en: "Haofei Tan",
    titleDisplay_en: ["2023 Master Student"],
    directions_en: [],
  },
  {
    name: "姚立民",
    title: "master",
    titleDisplay: ["2023级研究生"],
    email: "yaolimin18@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/ylm.jpg",
    name_en: "Limin Yao",
    titleDisplay_en: ["2023 Master Student"],
    directions_en: [],
  },
  {
    name: "张锦帆",
    title: "master",
    titleDisplay: ["2023级研究生"],
    email: "zjf_13867931237@163.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/zjf.jpg",
    name_en: "Jinfan Zhang",
    titleDisplay_en: ["2023 Master Student"],
    directions_en: [],
  },
  {
    name: "邓兆林",
    title: "master",
    titleDisplay: ["2023级研究生"],
    email: "dengzhaolin2023@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/dzl.jpg",
    name_en: "Zhaolin Deng",
    titleDisplay_en: ["2023 Master Student"],
    directions_en: [],
  },
  {
    name: "沈钰琦",
    title: "master",
    titleDisplay: ["2023级研究生"],
    email: "loveshenyuqi@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/syq.jpg",
    name_en: "Yuqi Shen",
    titleDisplay_en: ["2023 Master Student"],
    directions_en: [],
  },
  {
    name: "刘蔚瑶",
    title: "master",
    titleDisplay: ["2023级研究生"],
    email: "happyliu weiyao@163.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/lwy.jpg",
    name_en: "Weiyao Liu",
    titleDisplay_en: ["2023 Master Student"],
    directions_en: [],
  },
  {
    name: "李卓伦",
    title: "master",
    titleDisplay: ["2024级研究生"],
    email: "lzl@zjut.edu.cn",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/lzl.jpg",
    name_en: "Zhuolun Li",
    titleDisplay_en: ["2024 Master Student"],
    directions_en: [],
  },
  {
    name: "胡旭圆",
    title: "master",
    titleDisplay: ["2024级研究生"],
    email: "Hu.X.Y@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/hxy.jpg",
    name_en: "Xuyuan Hu",
    titleDisplay_en: ["2024 Master Student"],
    directions_en: [],
  },
  {
    name: "李宇龙",
    title: "master",
    titleDisplay: ["2024级研究生"],
    email: "lyltiantian@163.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/lyl.jpg",
    name_en: "Yulong Li",
    titleDisplay_en: ["2024 Master Student"],
    directions_en: [],
  },
  {
    name: "吴佳文",
    title: "master",
    titleDisplay: ["2024级研究生"],
    email: "bluewuu@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/wjw.jpg",
    name_en: "Jiawen Wu",
    titleDisplay_en: ["2024 Master Student"],
    directions_en: [],
  },
  {
    name: "周昊",
    title: "master",
    titleDisplay: ["2024级研究生"],
    email: "zh13305819151@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/zh2.jpg",
    name_en: "Hao Zhou",
    titleDisplay_en: ["2024 Master Student"],
    directions_en: [],
  },
  {
    name: "陈建林",
    title: "master",
    titleDisplay: ["2024级研究生"],
    email: "JL_Chen01@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/cjl.jpg",
    name_en: "Jianlin Chen",
    titleDisplay_en: ["2024 Master Student"],
    directions_en: [],
  },
  {
    name: "韩旭涛",
    title: "master",
    titleDisplay: ["2024级研究生"],
    email: "hxt_4585@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/hxt.jpg",
    name_en: "Xutao Han",
    titleDisplay_en: ["2024 Master Student"],
    directions_en: [],
  },
  {
    name: "宁凯丽",
    title: "master",
    titleDisplay: ["2024级研究生"],
    email: "kailili33@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/nkl.jpg",
    name_en: "Kaili Ning",
    titleDisplay_en: ["2024 Master Student"],
    directions_en: [],
  },
  {
    name: "胡逾越",
    title: "master",
    titleDisplay: ["2024级研究生"],
    email: "Huyuyue0417@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/hyy.jpg",
    name_en: "Yuyue Hu",
    titleDisplay_en: ["2024 Master Student"],
    directions_en: [],
  },
  {
    name: "郭旭",
    title: "master",
    titleDisplay: ["2024级研究生"],
    email: "gx6868668@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/gx.jpg",
    name_en: "Xu Guo",
    titleDisplay_en: ["2024 Master Student"],
    directions_en: [],
  },
  {
    name: "徐梦菲 ",
    title: "master",
    titleDisplay: ["2024级研究生"],
    email: "mengfeixu_2002@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/xmf.jpg",
    name_en: "Mengfei Xu",
    titleDisplay_en: ["2024 Master Student"],
    directions_en: [],
  },
  {
    name: "徐晨洋 ",
    title: "master",
    titleDisplay: ["2024级研究生"],
    email: "18258540349@163.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/xcy.jpg",
    name_en: "Chenyang Xu",
    titleDisplay_en: ["2024 Master Student"],
    directions_en: [],
  },
  {
    name: "孙亮 ",
    title: "master",
    titleDisplay: ["2024级研究生"],
    email: "outlook_C2406729D0D2D5C6@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/sunliang.jpg",
    name_en: "Liang Sun",
    titleDisplay_en: ["2024 Master Student"],
    directions_en: [],
  },
  {
    name: "吴一楠 ",
    title: "master",
    titleDisplay: ["2024级研究生"],
    email: "wyn_0124@163.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/wuyinan.jpg",
    name_en: "Yinan Wu",
    titleDisplay_en: ["2024 Master Student"],
    directions_en: [],
  },
  {
    name: "叶恺伦 ",
    title: "master",
    titleDisplay: ["2024级研究生"],
    email: "ykl20020329@163.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/yekailun.jpg",
    name_en: "Kailun Ye",
    titleDisplay_en: ["2024 Master Student"],
    directions_en: [],
  },
]

export const undergraduate: IMember[] = [

  {
    name: "徐浩然",
    title: "undergraduate",
    titleDisplay: ["2018级本科生"],
    email: "316709548@qq.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/undergraduate/xhr.jpg",
    name_en: "Haoran Xu",
    titleDisplay_en: ["2018 Undergraduate"],
    directions_en: [],
  },
  {
    name: "李文彬",
    title: "undergraduate",
    titleDisplay: ["2018级本科生"],
    email: "Li994210236@gmail.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/undergraduate/lwb.jpg",
    name_en: "Wenbin Li",
    titleDisplay_en: ["2018 Undergraduate"],
    directions_en: [],
  },
  {
    name: "陈一川",
    title: "undergraduate",
    titleDisplay: ["22级本科生"],
    email: "chenyc0715@gmail.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/undergraduate/cyc.jpg",
    name_en: "Yichuan Chen",
    titleDisplay_en: ["2022 Undergraduate"],
    directions_en: [],
  },
  {
    name: "陈奕哲",
    title: "undergraduate",
    titleDisplay: ["22级本科生"],
    email: "cyizhe628@gmail.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/undergraduate/cyz.jpg",
    name_en: "Yizhe Chen",
    titleDisplay_en: ["2022 Undergraduate"],
    directions_en: [],
  },
  {
    name: "裘立涵",
    title: "undergraduate",
    titleDisplay: ["24级本科生"],
    email: "qiulihan@zjut.edu.cn",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/undergraduate/qlh.jpg",
    name_en: "Lihan Qiu",
    titleDisplay_en: ["2024 Undergraduate"],
    directions_en: [],
  }
]

export const alumni: IMember[] = [
  {
    name: "周文峰",
    title: "alumni",
    titleDisplay: ["2023级博士"],
    email: "Wenfeng_Zhou98@outlook.com",
    directions: ["数据插补"],
    homepageUrl: null,
    photoSrc: "/images/members/phd/zwf.jpg",
    name_en: "Wenfeng Zhou",
    titleDisplay_en: ["2023 phD Student"],
    directions_en: ["Data imputation"],
  },
  {
    name: "毕俊辉",
    title: "alumni",
    titleDisplay: ["2022级研究生"],
    email: "JunhuiBi@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/bjh.jpg",
    name_en: "Junhui Bi",
    titleDisplay_en: ["2022 Master Student"],
    directions_en: [],
  },
  {
    name: "袁浩鹏",
    title: "alumni",
    titleDisplay: ["2022级研究生"],
    email: "hoperyuan@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/yhp.jpg",
    name_en: "Haopeng Yuan",
    titleDisplay_en: ["2022 Master Student"],
    directions_en: [],
  },
  {
    name: "李国文",
    title: "alumni",
    titleDisplay: ["2022级研究生"],
    email: "sydwx123@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/lgw.jpg",
    name_en: "Guowen Li",
    titleDisplay_en: ["2022 Master Student"],
    directions_en: [],
  },
  {
    name: "郑宏",
    title: "alumni",
    titleDisplay: ["2022级研究生"],
    email: "H.Zheng22@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/zh.jpg",
    name_en: "Hong Zheng",
    titleDisplay_en: ["2022 Master Student"],
    directions_en: [],
  },
  {
    name: "何雨薇",
    title: "alumni",
    titleDisplay: ["2022级研究生"],
    email: "Heyuwei1209@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/hyw.jpg",
    name_en: "Yuwei He",
    titleDisplay_en: ["2022 Master Student"],
    directions_en: [],
  },
  {
    name: "伊秋华",
    title: "alumni",
    titleDisplay: ["2022级研究生"],
    email: "qiuhuayi@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/yqh.jpg",
    name_en: "Qiuhua Yi",
    titleDisplay_en: ["2022 Master Student"],
    directions_en: [],
  },

  {
    name: "沈哲辉",
    title: "alumni",
    titleDisplay: ["2022级研究生"],
    email: "shenzhehui198@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/szh.jpg",
    name_en: "Zhehui Shen",
    titleDisplay_en: ["2022 Master Student"],
    directions_en: [],
  },
  {
    name: "刘晋",
    title: "alumni",
    titleDisplay: ["2022级研究生"],
    email: "aloha0617@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/lj.png",
    name_en: "Jin Liu",
    titleDisplay_en: ["2022 Master Student"],
    directions_en: [],
  },
  {
    name: "胡泽昊",
    title: "alumni",
    titleDisplay: ["2022级研究生"],
    email: "hzhmixi@gmail.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/hzh.jpg",
    name_en: "Zhehao Hu",
    titleDisplay_en: ["2022 Master Student"],
    directions_en: [],
  },
  {
    name: "邓俊慧",
    title: "alumni",
    titleDisplay: ["2022级研究生"],
    email: "deng_huanghuang@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/djh.jpg",
    name_en: "Junhui Deng",
    titleDisplay_en: ["2022 Master Student"],
    directions_en: [],
  },
  {
    name: "贺小骅",
    title: "alumni",
    titleDisplay: ["2022级研究生"],
    email: "ashleyhxh@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/hxh.jpg",
    name_en: "Xiaohua He",
    titleDisplay_en: ["2022 Master Student"],
    directions_en: [],
  },
  {
    name: "周泽海",
    title: "alumni",
    titleDisplay: ["2022级研究生"],
    email: "zehai_zhou@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/zzh.jpg",
    name_en: "Zhehai Zhou",
    titleDisplay_en: ["2022 Master Student"],
    directions_en: [],
  },
  {
    name: "周涵林",
    title: "alumni",
    titleDisplay: ["2021级研究生"],
    email: "zhouhanlin123s@gmail.com",
    directions: ["城市计算","智慧交通","联邦学习"],
    homepageUrl: null,
    photoSrc: "/images/members/master/zhl.png",
    name_en: "Hanlin Zhou",
    titleDisplay_en: ["2021 Master Student"],
    directions_en: ["Urban computing","Intelligent transportation","Federated learning"],
  },
  {
    name: "马旭林",
    title: "alumni",
    titleDisplay: ["2021级研究生"],
    email: "xulinma@outlook.com",
    directions: ["图神经网络","推荐系统"],
    homepageUrl: null,
    photoSrc: "/images/members/master/mxl.jpg",
    name_en: "Xulin Ma",
    titleDisplay_en: ["2021 Master Student"],
    directions_en: ["Graph Neural Network","Recommended system"],
  },
  {
    name: "王凌云",
    title: "alumni",
    titleDisplay: ["2021级研究生"],
    email: "kuluo_wly@outlook.com",
    directions: ["社会计算","联邦学习"],
    homepageUrl: null,
    photoSrc: "/images/members/master/wly.png",
    name_en: "Lingyun Wang",
    titleDisplay_en: ["2021 Master Student"],
    directions_en: ["Social computing","Federated learning"],
  },
  {
    name: "林航",
    title: "alumni",
    titleDisplay: ["2021级研究生"],
    email: "hanglin_1999@outlook.com",
    directions: ["城市计算","智慧交通"],
    homepageUrl: null,
    photoSrc: "/images/members/master/linhang.jpg",
    name_en: "Lingyun Wang",
    titleDisplay_en: ["2021 Master Student"],
    directions_en: ["Urban computing","Intelligent transportation"],
  },
  {
    name: "鲍寅威",
    title: "alumni",
    titleDisplay: ["2021级研究生"],
    email: "yinweibao@outlook.com",
    directions: ["社会计算","情感计算","联邦学习"],
    homepageUrl: null,
    photoSrc: "/images/members/master/byw.jpg",
    name_en: "Yinwei Bao",
    titleDisplay_en: ["2021 Master Student"],
    directions_en: ["Social computing","Affective computing","Federated learning"],
  },
  {
    name: "王奔锋",
    title: "alumni",
    titleDisplay: ["2021级研究生"],
    email: "bevanwang98@outlook.com",
    directions: ["城市计算","智慧交通","机器学习"],
    homepageUrl: null,
    photoSrc: "/images/members/master/wbf.jpg",
    name_en: "Benfeng Wang",
    titleDisplay_en: ["2021 Master Student"],
    directions_en: ["Urban computing","Intelligent transportation","Machine Learing"],
  },

  {
    name: "陈之瑜",
    title: "alumni",
    titleDisplay: ["2021级研究生"],
    email: "fatfatant66@gmail.com",
    directions: ["交通流预测"],
    homepageUrl: null,
    photoSrc: "/images/members/master/czy.jpg",
    name_en: "Zhiyu Chen",
    titleDisplay_en: ["2021 Master Student"],
    directions_en: ["Traffic flow forecast"],
  },
  {
    name: "王钧涛",
    title: "alumni",
    titleDisplay: ["2021级研究生"],
    email: "jasonwangofzj@gmail.com",
    directions: ["城市计算","智慧城市"],
    homepageUrl: null,
    photoSrc: "/images/members/master/wjt.jpg",
    name_en: "Juntai Wang",
    titleDisplay_en: ["2021 Master Student"],
    directions_en: ["Urban computing","Intelligent city"],
  },
  {
    name: "杨筱雪",
    title: "alumni",
    titleDisplay: ["2021级研究生"],
    email: "uuu_yang@outlook.com",
    directions: ["城市计算","数据科学"],
    homepageUrl: null,
    photoSrc: "/images/members/master/yxx.jpg",
    name_en: "Xiaoxue Yang",
    titleDisplay_en: ["2021 Master Student"],
    directions_en: ["Urban computing","Data science"],
  },
  {
    name: "李欢",
    title: "alumni",
    titleDisplay: ["2021级研究生"],
    email: "zjutlihuan@outlook.com",
    directions: ["城市计算","智慧交通"],
    homepageUrl: null,
    photoSrc: "/images/members/master/lihuan.jpg",
    name_en: "Huan Li",
    titleDisplay_en: ["2021 Master Student"],
    directions_en: ["Urban computing","Intelligent transportation"],
  },
  {
    name: "张德举",
    title: "alumni",
    titleDisplay: ["2021级研究生"],
    email: "deju0123@outlook.com",
    directions: ["城市计算","智慧交通","图神经网络"],
    homepageUrl: null,
    photoSrc: "/images/members/master/zdj.jpg",
    name_en: "Deju Zhang",
    titleDisplay_en: ["2021 Master Student"],
    directions_en: ["Urban computing","Intelligent transportation","Graph Neural Network"],
  },
  {
    name: "朱柘潮",
    title: "alumni",
    titleDisplay: ["2021级研究生"],
    email: "ZhechaoZhu@outlook.com",
    directions: ["情感计算","自然语言处理","情感分析"],
    homepageUrl: null,
    photoSrc: "/images/members/master/zzc.jpg",
    name_en: "Zhechao Zhu",
    titleDisplay_en: ["2021 Master Student"],
    directions_en: ["Affective computing","NLP","emotion analysis"],
  },
  {
    name: "檀佳佳",
    title: "alumni",
    titleDisplay: ["2019级研究生"],
    email: "ltguan@outlook.com",
    directions: [],
    homepageUrl: "http://47.93.57.11:8443/",
    photoSrc: "/images/members/alumni/tjj.png",
    name_en: "Jiajia Tan",
    titleDisplay_en: ["2019 Master Student"],
    directions_en: [],
  },
  {
    name: "朱秉",
    title: "alumni",
    titleDisplay: ["2019级研究生"],
    email: "BingZhu97@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/alumni/zb.jpg",
    name_en: "Bing Zhu",
    titleDisplay_en: ["2019 Master Student"],
    directions_en: [],
  },
  {
    name: "李宁",
    title: "alumni",
    titleDisplay: ["2019级研究生"],
    email: "NingLi68@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/alumni/ln.jpg",
    name_en: "Ning Li",
    titleDisplay_en: ["2019 Master Student"],
    directions_en: [],
  },
  {
    name: "许鑫博",
    title: "alumni",
    titleDisplay: ["2019级研究生"],
    email: "XinboXu@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/alumni/xxb.png",
    name_en: "Xinbo Xu",
    titleDisplay_en: ["2019 Master Student"],
    directions_en: [],
  },
  {
    name: "沈阳",
    title: "alumni",
    titleDisplay: ["2019级研究生"],
    email: "yangshen014@outlook.com",
    directions: ["强化学习"],
    homepageUrl: null,
    photoSrc: "/images/members/alumni/sy.png",
    name_en: "Yang Shen",
    titleDisplay_en: ["2019 Master Student"],
    directions_en: ["Reinforcement learning"],
  },
  {
    name: "陈洋",
    title: "alumni",
    titleDisplay: ["2019级研究生"],
    email: "yangchen_97@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/alumni/cy.png",
    name_en: "Yang Chen",
    titleDisplay_en: ["2019 Master Student"],
    directions_en: [],
  },
  {
    name: "许敏浩",
    title: "alumni",
    titleDisplay: ["2019级研究生"],
    email: "XuMinHao2020@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/alumni/xmh.png",
    name_en: "Minhao Xu",
    titleDisplay_en: ["2019 Master Student"],
    directions_en: [],
  },
  {
    name: "韩笑",
    title: "alumni",
    titleDisplay: ["2018级研究生"],
    email: "hahahenha@gmail.com",
    directions: ["图卷积", "交通状况识别"],
    homepageUrl: "https://www.hahahenha.net/alpha-test/CV",
    photoSrc: "/images/members/alumni/hx.png",
    name_en: "Xiao Han",
    titleDisplay_en: ["2018 Master Student"],
    directions_en: ["Graph convolution", "Traffic situation recognition"],
  },
  {
    name: "余凯峰",
    title: "alumni",
    titleDisplay: ["2018级研究生"],
    email: "kfyu1996@outlook.com",
    directions: ["交通流预测"],
    homepageUrl: null,
    photoSrc: "/images/members/alumni/ykf.png",
    name_en: "Kaifeng Yu",
    titleDisplay_en: ["2018 Master Student"],
    directions_en: ["Traffic flow forecast"],
  },
  {
    name: "管林涛",
    title: "alumni",
    titleDisplay: ["2018级研究生"],
    email: "ltguan@outlook.com",
    directions: ["交通流预测"],
    homepageUrl: null,
    photoSrc: "/images/members/alumni/glt.jpg",
    name_en: "Lintao Guan",
    titleDisplay_en: ["2018 Master Student"],
    directions_en: ["Traffic flow forecast"],
  },
  {
    name: "王锦梦",
    title: "alumni",
    titleDisplay: ["2018级研究生"],
    email: "Jiuzuikurong@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/alumni/wjm.jpg",
    name_en: "Jinmeng Wang",
    titleDisplay_en: ["2018 Master Student"],
    directions_en: [],
  },
  {
    name: "舒文迪",
    title: "alumni",
    titleDisplay: ["2018级研究生"],
    email: "wendyshu43@gmail.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/alumni/swd.jpg",
    name_en: "Wendi Shu",
    titleDisplay_en: ["2018 Master Student"],
    directions_en: [],
  },
  {
    name: "唐龙峰",
    title: "alumni",
    titleDisplay: ["2017级研究生"],
    email: "t_lfeng@163.com",
    directions: ["交通流预测", "注意力机制"],
    homepageUrl: null,
    photoSrc: "/images/members/alumni/tlf.png",
    name_en: "Longfeng Tang",
    titleDisplay_en: ["2017 Master Student"],
    directions_en: ["Traffic flow prediction", "Attention mechanism"],
  },
  {
    name: "朱翔宇",
    title: "alumni",
    titleDisplay: ["2017级研究生"],
    email: "393729428@qq.com",
    directions: ["交通信号控制"],
    homepageUrl: null,
    photoSrc: "/images/members/alumni/zxy.png",
    name_en: "Xiangyu Zhu",
    titleDisplay_en: ["2017 Master Student"],
    directions_en: ["Traffic signal control"],
  },
  {
    name: "朱林峰",
    title: "alumni",
    titleDisplay: ["2016级研究生"],
    email: "516228548@qq.com",
    directions: ["行人跟踪"],
    homepageUrl: null,
    photoSrc: "/images/members/alumni/zlf.png",
    name_en: "Linfeng Zhu",
    titleDisplay_en: ["2016 Master Student"],
    directions_en: ["Pedestrian tracking"],
  },
  {
    name: "郦鹏飞",
    title: "alumni",
    titleDisplay: ["2020级研究生"],
    email: "lpf19961223@outlook.com",
    directions: ["城市计算","车辆轨迹预测"],
    homepageUrl: null,
    photoSrc: "/images/members/alumni/lpf.png",
    name_en: "Pengfei Li",
    titleDisplay_en: ["2020 Master Student"],
    directions_en: ["Urban computing","trajectory prediction"],
  },
  {
    name: "熊海涛",
    title: "alumni",
    titleDisplay: ["2020级研究生"],
    email: "HaitaoXiong@outlook.com",
    directions: ["联邦学习","蜂窝流量预测"],
    homepageUrl: null,
    photoSrc: "/images/members/alumni/xht.png",
    name_en: "Haitao Xiong",
    titleDisplay_en: ["2020 Master Student"],
    directions_en: ["Federated learning","Cellular traffic forecast"],
  },
  {
    name: "刘娜利",
    title: "alumni",
    titleDisplay: ["2020级研究生"],
    email: "nali_liu96@outlook.com",
    directions: ["机器学习","数据修复"],
    homepageUrl: null,
    photoSrc: "/images/members/alumni/lnl.png",
    name_en: "Nali Liu",
    titleDisplay_en: ["2020 Master Student"],
    directions_en: ["Machine learning","Data repair"],
  },
  {
    name: "张艳",
    title: "alumni",
    titleDisplay: ["2020级研究生"],
    email: "nameyzhang@gmail.com",
    directions: ["图神经网络","隐私保护"],
    homepageUrl: null,
    photoSrc: "/images/members/alumni/zy.png",
    name_en: "Yan Zhang",
    titleDisplay_en: ["2020 Master Student"],
    directions_en: ["Graph Neural Network","privacy protection"],
  },
  {
    name: "季展豪",
    title: "alumni",
    titleDisplay: ["2020级研究生"],
    email: "ZhanhaoJi@outlook.com",
    directions: ["城市计算","智慧交通"],
    homepageUrl: null,
    photoSrc: "/images/members/alumni/jzh.jpg",
    name_en: "Zhanhao Ji",
    titleDisplay_en: ["2020 Master Student"],
    directions_en: ["Urban computing","Intelligent transportation"],
  },
  {
    name: "卞纪新",
    title: "alumni",
    titleDisplay: ["2020级研究生"],
    email: "jixinbian@outlook.com",
    directions: ["城市计算","智慧交通","交通流预测"],
    homepageUrl: null,
    photoSrc: "/images/members/alumni/bjx.jpg",
    name_en: "Jixin Bian",
    titleDisplay_en: ["2020 Master Student"],
    directions_en: ["Urban computing","Intelligent transportation","Traffic flow forecast"],
  },
  {
    name: "黄志强",
    title: "alumni",
    titleDisplay: ["2020级研究生"],
    email: "zqhuang23@outlook.com",
    directions: ["城市计算","智慧城市"],
    homepageUrl: null,
    photoSrc: "/images/members/alumni/hzq.jpg",
    name_en: "Zhiqiang Huang",
    titleDisplay_en: ["2020 Master Student"],
    directions_en: ["Urban computing","Intelligent city"],
  },
  {
    name: "徐翼飞",
    title: "alumni",
    titleDisplay: ["2020级研究生"],
    email: "2112012063@zjut.edu.cn",
    directions: ["情感计算","自然语言处理","属性级情感分析"],
    homepageUrl: null,
    photoSrc: "/images/members/alumni/xyf.jpg",
    name_en: "Yifei Xu",
    titleDisplay_en: ["2020 Master Student"],
    directions_en: ["Affective computing","NLP","Attribute-level sentiment analysis"],
  },
  {
    name: "冯彪",
    title: "master",
    titleDisplay: ["2025级研究生"],
    email: "biaofeng2025@gmail.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/fb.jpg",
    name_en: "Biao Feng",
    titleDisplay_en: ["2025 Master Student"],
    directions_en: [],
  },
  {
    name: "吴绍坤",
    title: "master",
    titleDisplay: ["2025级研究生"],
    email: "wushaokun66@gmail.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/wsk.png",
    name_en: "Shaokun Wu",
    titleDisplay_en: ["2025 Master Student"],
    directions_en: [],
  },{
    name: "翟子豪",
    title: "master",
    titleDisplay: ["2025级研究生"],
    email: "zzh13592365333@gmail.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/zzh.png",
    name_en: "Zihao Zhai",
    titleDisplay_en: ["2025 Master Student"],
    directions_en: [],
  },
  {
    name: "吴怀静",
    title: "master",
    titleDisplay: ["2025级研究生"],
    email: "66667777WHJ@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/whj.png",
    name_en: "Huaijing Wu",
    titleDisplay_en: ["2025 Master Student"],
    directions_en: [],
  },
  {
    name: "郑茹丹",
    title: "master",
    titleDisplay: ["2025级研究生"],
    email: "ZIRanDe22@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/zrd.png",
    name_en: "Rudan Zheng",
    titleDisplay_en: ["2025 Master Student"],
    directions_en: [],
  },
  {
    name: "胡雷",
    title: "master",
    titleDisplay: ["2025级研究生"],
    email: "huleinb@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/hl.png",
    name_en: "Lei Hu",
    titleDisplay_en: ["2025 Master Student"],
    directions_en: [],
  },
  {
    name: "刘博韬",
    title: "master",
    titleDisplay: ["2025级研究生"],
    email: "azurlaneumikaze@gmail.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/lbt.png",
    name_en: "Botao Liu",
    titleDisplay_en: ["2025 Master Student"],
    directions_en: [],
  },
  {
    name: "周润佳",
    title: "master",
    titleDisplay: ["2025级研究生"],
    email: "runjiazhou86@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/zrj.jpg",
    name_en: "Runjia Zhou",
    titleDisplay_en: ["2025 Master Student"],
    directions_en: [],
  },
  {
    name: "袁志杰",
    title: "master",
    titleDisplay: ["2025级研究生"],
    email: "helloworle@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/yzj.png",
    name_en: "Zhijie Yuan",
    titleDisplay_en: ["2025 Master Student"],
    directions_en: [],
  },
  {
    name: "李志诚",
    title: "master",
    titleDisplay: ["2025级研究生"],
    email: "202103150108@zjut.edu.cn",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/lzc.png",
    name_en: "Zhicheng Li",
    titleDisplay_en: ["2025 Master Student"],
    directions_en: [],
  },
  {
    name: "林子涵",
    title: "master",
    titleDisplay: ["2025级研究生"],
    email: "linzz315@163.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/lzh.png",
    name_en: "Zihan Lin",
    titleDisplay_en: ["2025 Master Student"],
    directions_en: [],
  },
  {
    name: "温蓝杰",
    title: "master",
    titleDisplay: ["2025级研究生"],
    email: "jie11wen@163.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/wlj.jpg",
    name_en: "Lanjie Wen",
    titleDisplay_en: ["2025 Master Student"],
    directions_en: [],
  },
  {
    name: "方娅晴",
    title: "master",
    titleDisplay: ["2025级研究生"],
    email: "15088672148@163.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/fyq.png",
    name_en: "Yaqing Fang",
    titleDisplay_en: ["2025 Master Student"],
    directions_en: [],
  },
  {
    name: "李佳乐",
    title: "master",
    titleDisplay: ["2025级研究生"],
    email: "17863661108@163.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/ljl.png",
    name_en: "Jiale Li",
    titleDisplay_en: ["2025 Master Student"],
    directions_en: [],
  },
  {
    name: "高宇坚",
    title: "master",
    titleDisplay: ["2025级研究生"],
    email: "G_J1an@163.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/gyj.png",
    name_en: "Yujian Gao",
    titleDisplay_en: ["2025 Master Student"],
    directions_en: [],
  },
  {
    name: "赵晨晨",
    title: "master",
    titleDisplay: ["2025级研究生"],
    email: "z341602@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/zcc.png",
    name_en: "Chenchen Zhao",
    titleDisplay_en: ["2025 Master Student"],
    directions_en: [],
  },
  {
    name: "蔡雨润",
    title: "master",
    titleDisplay: ["2025级研究生"],
    email: "caiyurun1022@outlook.com",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/cyr.png",
    name_en: "Yurun Cai",
    titleDisplay_en: ["2025 Master Student"],
    directions_en: [],
  },
  {
    name: "赖志杰",
    title: "master",
    titleDisplay: ["2025级研究生"],
    email: "kriyalai@yeah.net",
    directions: [],
    homepageUrl: null,
    photoSrc: "/images/members/master/lzj.png",
    name_en: "Zhijie Lai",
    titleDisplay_en: ["2025 Master Student"],
    directions_en: [],
  }
]


export const members = [...faculty, ...phd, ...master, ...undergraduate, ...alumni];
